/**
 * Class representing a replacement status update object
 */
export class ReplacementStatusUpdate {
  /**
   * Create an object for image update.
   * @param {Boolean} replacementItemsConfirmed - if the user confirms the offer
   * @param {String} replacementStatusReason - in case of decline, user's reason
   */
  constructor (options) {
    this.replacementItemsConfirmed = options.replacementItemsConfirmed
    this.replacementStatusReason = options.replacementStatusReason
  }

  get replacementItemsConfirmed () {
    return this._replacementItemsConfirmed
  }

  set replacementItemsConfirmed (value) {
    this._replacementItemsConfirmed = value
  }

  get replacementStatusReason () {
    return this._replacementStatusReason
  }

  set replacementStatusReason (value) {
    this._replacementStatusReason = value
  }

  toJSON () {
    return {
      replacementItemsConfirmed: this._replacementItemsConfirmed,
      replacementStatusReason: this._replacementStatusReason
    }
  }
}
